import { useState, useEffect } from "react";
import EnsightenAnalytics from "../Utility/EnsightenAnalytics";

import OneXButton from "../OneX/OneXButton";
import { useMedia } from "use-media";
import OneXSpecs from "../OneX/OneXSpecs";

const QuoteUnavailable = () => {
  const [init, setInit] = useState(false);

  const isMobile = useMedia(OneXSpecs.DEVICE_MEDIA_QUERIES.MOBILE);
  const isTablet = useMedia(OneXSpecs.DEVICE_MEDIA_QUERIES.TABLET);
  const isDesktop = useMedia(OneXSpecs.DEVICE_MEDIA_QUERIES.DESKTOP);

  //const successfulMatch = useRecoilValue(successfulMatchState);

  useEffect(() => {
    if (!init) {
      EnsightenAnalytics.pushScreenChangeToAnalytics("quote-unavailable");
      setInit(true);
    }
  }, [init]);

  return (
    <div
      role="alert"
      aria-label="Error"
      aria-live="assertive"
      className={"-oneX-col-lg-9 -oneX-col-md-10 -oneX-col-sm-10"}
      style={{
        marginBottom: "224px"
      }}>
      <h1
        style={{ marginTop: isDesktop ? "56px" : isTablet ? "48px" : isMobile ? "40px" : "40px", marginBottom: "28px" }}
      >
        Sorry, we can’t load this quote
      </h1>
      <div className={"-oneX-body--intro"} style={{ marginBottom: "38px" }}>
        Your saved quote is unavailable at this time. Call your agent if you need immediate access to this quote.
      </div>
      <OneXButton
        id="RtH_Btn"
        type={"primary"}
        clickHandler={() => {
          window.location.href = "https://www.statefarm.com/";
        }}
        size={"large"}
      >
        {"Go back to statefarm.com"}
      </OneXButton>
    </div>
  );
};

export default QuoteUnavailable;
